const auth = {
  TOKEN: 'auth-token',
  USER: 'auth-user',
}

export default auth
